import { render, staticRenderFns } from "./AppVersionCheck.vue?vue&type=template&id=0f48df5a&scoped=true"
import script from "./AppVersionCheck.vue?vue&type=script&lang=js"
export * from "./AppVersionCheck.vue?vue&type=script&lang=js"
import style0 from "./AppVersionCheck.vue?vue&type=style&index=0&id=0f48df5a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f48df5a",
  null
  
)

export default component.exports